import React, { useContext } from 'react';
import { View } from 'react-native';
import { Button, Input, Text } from '@rneui/themed';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import Styles from './styles';
import { post } from '../../../../common/Api';
import AppContext from '../../../../contexts/App';
import LayoutContext from '../../../../contexts/Layout';
import RegistrationContext, { Actions } from '../../../../contexts/Registration';

const RegistrationStep4 = ({ control, getValues, isValid, setError }) => {
    const { state: appState } = useContext(AppContext);
    const { state, dispatch } = useContext(RegistrationContext);
    const { layout } = useContext(LayoutContext);

    const handleTextConfirmation = async () => {
        const confirmationCode = getValues('mobileConfirmationCode');

        if (confirmationCode && state.emailConfirmationId) {
            const endpoint = `${appState.settings.openIdSettings.authority}/Account/VerifyConfirmationCode`;
            const response = await post(endpoint, { confirmationCodeId: state.mobileConfirmationId, confirmationCode });

            if (response?.success) {
                dispatch({ type: Actions.NEXT });
            } else {
                setError('mobileConfirmationCode', {
                    type: 'custom',
                    message: 'Code does not match our records, please make sure you entered it correctly.'
                });
            }
        }
    };

    return (
        <View style={{ width: '100%' }} testID='Registration.Step4'>
            <View style={{ flexDirection: 'row', marginHorizontal: layout.styleGuide.gutter }}>
                <Text style={Styles.introductionText}>Please enter the confirmation code that was sent to your mobile device.</Text>
            </View>
            <View style={{ flexDirection: 'row', width: '100%' }}>
                <Controller
                    control={control}
                    defaultValue=''
                    name='mobileConfirmationCode'
                    render={({ field, fieldState }) => {
                        return (
                            <Input
                                {...field}
                                containerStyle={{ width: '100%', marginVertical: 20 }}
                                errorMessage={!fieldState.error ? 'Confirmation Code' : fieldState.error?.message}
                                errorStyle={!fieldState.error ? Styles.placeholderStyle : Styles.errorStyle}
                                innerRef={field.ref}
                                inputStyle={Styles.smallInputStyle}
                                onChangeText={val => field.onChange(val)}
                                textContentType='oneTimeCode'
                                spellCheck={false}
                            />
                        );
                    }}
                    rules={{
                        required: {
                            message: 'Confirmation Code is required',
                            value: true
                        }
                    }}
                />
            </View>
            <Button
                buttonStyle={Styles.stepButton}
                containerStyle={Styles.stepButtonContainer}
                disabled={!isValid}
                disabledStyle={Styles.disabledStepButton}
                disabledTitleStyle={Styles.disabledStepButtonTitle}
                onPress={() => handleTextConfirmation()}
                title='NEXT STEP'
                titleStyle={Styles.stepButtonTitle}
                type='solid'
            />
        </View>
    );
};

RegistrationStep4.propTypes = {
    control: PropTypes.object.isRequired,
    getValues: PropTypes.func.isRequired,
    isValid: PropTypes.bool.isRequired,
    setError: PropTypes.func.isRequired
};

export default RegistrationStep4;
